export default __webpack_public_path__ + "static/MainCyberBackground-d9d5019ba66b291ced31272cb0dde1f9.jpg";